import { t, type KaannosAvain } from "./kieli";
import { naytaPvm } from "./pvm";

/**
 * kuvanimi.ts — kuvan näyttönimi (274, T547; Toni 29.10.2026 klo 15.22).
 *
 * «Listoissa ja luovutusdokumentaatiossa näytetään nimi, ja jos se puuttuu, laji ja päivä, ei tiedostonimeä.» Laji näytetään nimen
 * edessä, kun se on valittu (31.10. kohta 2). Tiedostonimi
 * (`alkuperainen`) säilyy taustalla: puhelimen kuvassa se on «WhatsApp Image 2026-10-19 at 18.36.44.jpeg», joka ei kerro mitään
 * ja päätyi 29.10. asti luovutusdokumenttiin. Yksi funktio kaikille näkymille, ettei yksikään palaa tiedostonimeen omalla tavallaan.
 *
 * `tt` = käännösfunktio: näkymässä `t` (käyttöliittymän kieli), tulosteessa `tDok` (dokumentin kieli).
 */
export type KuvaLaji = "kuvaus" | "sijainti" | "sijainti_3d";
export const KUVALAJIT: KuvaLaji[] = ["kuvaus", "sijainti", "sijainti_3d"];

export function kuvanNimi(
  l: { nimi?: string | null; kuvalaji?: string | null; lisatty?: string | null },
  tt: (a: KaannosAvain, m?: Record<string, string | number>) => string = t,
): string {
  // Toni 31.10.2026 klo 08.40 kohta 2: laji myös nimetyn kuvan kanssa («Sijainti · Venttiilin V-12 sijainti») — luovutusaineistossa laji
  // kertoo, mitä kuva on. Nimetty kuva ilman lajia: pelkkä nimi.
  if (l.nimi && l.nimi.trim()) {
    return l.kuvalaji ? `${tt(`liite.kuvalaji.${l.kuvalaji}` as KaannosAvain)} · ${l.nimi.trim()}` : l.nimi.trim();
  }
  const laji = tt((l.kuvalaji ? `liite.kuvalaji.${l.kuvalaji}` : "liite.kuvalaji.ei") as KaannosAvain);
  const pvm = naytaPvm(l.lisatty ?? null);
  return pvm ? `${laji} · ${pvm}` : laji;
}
